import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { LuMenu, LuX } from "react-icons/lu";
import { PROJECT_NAME, LOGO_PATH } from "../../utils/constants";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    // { label: "Pricing", path: "/pricing" },
    // { label: "Contact", path: "/contact" },
  ];

  const MenuButtons = ({ isMobile = false }) => (
    <>
      {navLinks.map((link, idx) => (
        <button
          key={idx}
          onClick={() => {
            navigate(link.path);
            if (isMobile) setMenuOpen(false);
          }}
          className={`font-medium transition ${isMobile
              ? "block w-full text-left text-white hover:text-red-500"
              : "text-white hover:text-red-500 relative"
            }`}
        >
          {link.label}
          {!isMobile && (
            <span className="absolute left-0 -bottom-1 w-0 h-0.5 bg-red-500 transition-all duration-300 group-hover:w-full"></span>
          )}
        </button>
      ))}
    </>
  );

  return (
    <header className="absolute top-0 left-0 w-full z-50">
      <nav className="container mx-auto flex items-center justify-between py-3 px-4 md:px-8">
        {/* Logo */}
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img src={LOGO_PATH} alt="Logo" className="w-10 h-auto" />
          <span className="text-xl font-bold text-white">{PROJECT_NAME}</span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-6">
          <MenuButtons />
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <LuX size={28} className="text-white" /> : <LuMenu size={28} className="text-white" />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden absolute top-14 left-0 w-full p-4 space-y-3 bg-black/90 backdrop-blur-md shadow-lg rounded-b-2xl">
          <MenuButtons isMobile />
        </div>
      )}
    </header>
  );
};

export default Navbar;
